// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"da933cd4","555":"a8ef6ea2"}[chunkId] + ".chunk.js";
};